import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Paper,
  Grid,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Stack,
  TableFooter,
  Tabs,
  Tab,
  TextField,
  MenuItem,
  Box,
  Dialog,
  DialogTitle,
} from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import SearchIcon from "@mui/icons-material/Search";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import dayjs from "dayjs";
import "dayjs/locale/vi";

import invoiceApi from "../api/invoiceApi";
import invoiceTemplateApi from "../api/invoiceTemplateApi";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import ConfirmDialog from "../components/ConfirmDialog";

dayjs.locale("vi");
const searchType = [
  { value: 0, label: "Theo ngày" },
  { value: 1, label: "Theo tháng" },
  { value: 2, label: "Theo quý" },
  { value: 3, label: "Theo năm" },
  { value: 4, label: "Theo tháng trong năm" },
  { value: 5, label: "Theo quý trong năm" },
];
const tabs = [
  { value: 0, label: "Báo cáo xuất hóa đơn", fileType: "xlsx" },
  { value: 1, label: "Mẫu S1a-HKD", fileType: "pdf" },
  { value: 2, label: "Mẫu S2a-HKD", fileType: "pdf" },
  { value: 3, label: "Mẫu S2b-HKD", fileType: "pdf" },
  { value: 4, label: "Mẫu S2c-HKD", fileType: "pdf" },
];

const SalesRevenueReportPage = () => {
  const user = useSelector((state) => state.auth.user);
  const customerInfor = useSelector((state) => state.auth.customerInfor);

  const [fromDate, setFromDate] = useState(dayjs().startOf("month"));
  const [toDate, setToDate] = useState(dayjs());
  const [invoices, setInvoices] = useState([]);
  const [summary, setSummary] = useState({
    TotalRevenue: 0,
    TotalAllGtgt: 0,
    TotalAllTncn: 0,
  });
  const [symbol, setSymbol] = useState("-1");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [invoiceTemplate, setInvoiceTemplate] = useState([]);
  const [confirmDialogState, setConfirmDialogState] = useState({
    open: false,
    title: "",
    content: "",
    onConfirm: () => {},
    onClose: () => {},
  });
  const [type, setType] = useState(0);
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  // Tạo mảng năm từ 1900 đến năm hiện tại (đảo ngược để năm mới nhất lên đầu)
  const years = Array.from(
    { length: currentYear - 1900 + 1 },
    (_, index) => 1900 + index,
  ).reverse();

  const getCurrentQuarter = () => Math.floor((new Date().getMonth() + 3) / 3);
  const [quarter, setQuarter] = useState(getCurrentQuarter());
  const quarters = [
    { value: 1, label: "Quý 1 (Tháng 1 - 3)" },
    { value: 2, label: "Quý 2 (Tháng 4 - 6)" },
    { value: 3, label: "Quý 3 (Tháng 7 - 9)" },
    { value: 4, label: "Quý 4 (Tháng 10 - 12)" },
  ];
  const quarterAll = [
    { value: -1, label: "Cả năm" },
    { value: 1, label: "Quý 1 (Tháng 1 - 3)" },
    { value: 2, label: "Quý 2 (Tháng 4 - 6)" },
    { value: 3, label: "Quý 3 (Tháng 7 - 9)" },
    { value: 4, label: "Quý 4 (Tháng 10 - 12)" },
  ];

  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const months = Array.from({ length: 12 }, (_, i) => i + 1);

  const formatVND = (amount) => {
    if (amount === undefined || amount === null) return null;
    return amount.toLocaleString("vi-VN");
  };
  const [currentTab, setCurrentTab] = useState(0); // State để quản lý Tab đang chọn
  const [openDialogChoice, setOpenDialogChoice] = useState(false);
  const [yearForRecalculate, setYearForRecalculate] = useState(currentYear);
  const [quarterForRecalculate, setQuarterForRecalculate] =
    useState(getCurrentQuarter());

  // Style chung cho các ô dính ở đáy (Sticky Footer)
  const stickyFooterStyle = {
    position: "sticky",
    bottom: 0,
    backgroundColor: "#fff9c4", // Màu nền để không bị lộ dữ liệu bên dưới khi cuộn
    zIndex: 1,
  };
  useEffect(() => {
    async function fetchInvoiceTemplate() {
      try {
        const response = await invoiceTemplateApi.searchTemplates(
          customerInfor.CusId,
          "",
          0,
          100,
        );
        if (response.success) {
          setInvoiceTemplate((prev) => [
            { value: -1, label: "Tất cả" },
            ...response.data.result.map((x) => ({
              value: x.ItId,
              label: x.ItIsActive ? (
                x.signName
              ) : (
                <s style={{ textDecorationColor: "red" }}>
                  {x.signName + "(ngưng)"}
                </s>
              ),
            })),
          ]);
        } else {
          setInvoiceTemplate([{ value: -1, label: "Tất cả" }]);
          console.error("Error fetchInvoiceTemplate: " + response.message);
        }
      } catch (error) {
        setInvoiceTemplate([{ value: -1, label: "Tất cả" }]);
        console.error("Error fetchInvoiceTemplate: " + error.message);
      } finally {
      }
    }
    fetchInvoiceTemplate();
  }, []);

  const ExportInvoiceReport = async (exportType) => {
    try {
      let dateFrom = fromDate;
      let dateTo = toDate;
      if (type === 1) {
        dateFrom = dayjs()
          .set("year", year)
          .set("month", month - 1)
          .startOf("month");
        dateTo = dayjs()
          .set("year", year)
          .set("month", month - 1)
          .endOf("month");
      }
      if (type === 2) {
        switch (quarter) {
          case 1:
            dateFrom = dayjs().set("year", year).set("month", 0).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 2).set("date", 31);
            break;
          case 2:
            dateFrom = dayjs().set("year", year).set("month", 3).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 5).set("date", 30);
            break;
          case 3:
            dateFrom = dayjs().set("year", year).set("month", 6).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 8).set("date", 30);
            break;
          case 4:
            dateFrom = dayjs().set("year", year).set("month", 9).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 11).set("date", 31);
            break;
          default:
            break;
        }
      }
      if (type === 3 || type === 4 || type == 5) {
        dateFrom = dayjs().set("year", year).set("month", 0).set("date", 1);
        dateTo = dayjs().set("year", year).set("month", 11).set("date", 31);
      }
      if (exportType > 2) {
        toast.error("Mẫu chưa có sẵn");
        return;
      }
      let response = {};
      if (exportType === 0) {
        response = await invoiceApi.GetInvoiceSummaryReport(
          true,
          dateFrom,
          dateTo,
          customerInfor.CusId,
          symbol === "-1" ? null : symbol,
          type,
        );
      } else {
        response = await invoiceApi.GetSalesRevenueReport(
          true,
          dateFrom,
          dateTo,
          customerInfor.CusId,
          exportType,
        );
      }

      const binaryData = response.data; // Lấy phần nội dung nhị phân

      if (
        !(binaryData instanceof Blob) &&
        !(binaryData instanceof ArrayBuffer)
      ) {
        toast.error("Lỗi xử lý dữ liệu!");
        console.error("Dữ liệu không phải nhị phân! Kiểm tra responseType.");
      }

      const blob = new Blob([binaryData]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      const current = tabs.find((x) => x.value === exportType);
      link.setAttribute("download", current.label + "." + current.fileType);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error(error);
    } finally {
    }
  };
  const GetSalesRevenueReport = async (exportType) => {
    try {
      let dateFrom = fromDate;
      let dateTo = toDate;
      if (type === 1) {
        dateFrom = dayjs()
          .set("year", year)
          .set("month", month - 1)
          .startOf("month");
        dateTo = dayjs()
          .set("year", year)
          .set("month", month - 1)
          .endOf("month");
      }
      if (type === 2) {
        switch (quarter) {
          case 1:
            dateFrom = dayjs().set("year", year).set("month", 0).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 2).set("date", 31);
            break;
          case 2:
            dateFrom = dayjs().set("year", year).set("month", 3).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 5).set("date", 30);
            break;
          case 3:
            dateFrom = dayjs().set("year", year).set("month", 6).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 8).set("date", 30);
            break;
          case 4:
            dateFrom = dayjs().set("year", year).set("month", 9).set("date", 1);
            dateTo = dayjs().set("year", year).set("month", 11).set("date", 31);
            break;
          default:
            break;
        }
      }
      if (type === 3 || type === 4 || type == 5) {
        dateFrom = dayjs().set("year", year).set("month", 0).set("date", 1);
        dateTo = dayjs().set("year", year).set("month", 11).set("date", 31);
      }

      if (exportType === 0) {
        const response = await invoiceApi.GetInvoiceSummaryReport(
          false,
          dateFrom,
          dateTo,
          customerInfor.CusId,
          symbol === "-1" ? null : symbol,
          type,
        );
        if (response.success) {
          setInvoices(response.data.Invoices);
          setSummary(response.data.Summary);
        } else {
          toast.error(response.message);
          setInvoices([]);
          setSummary({
            TotalInvoice: 0,
            TotalInvoiceSync: 0,
            TotalInvoiceSign: 0,
            TotalItemAmount: 0,
            TotalDiscountAmount: 0,
            TotalBeforeTax: 0,
            TotalVatAmount: 0,
            TotalAfterTax: 0,
          });
        }
      } else {
        const response = await invoiceApi.GetSalesRevenueReport(
          false,
          dateFrom,
          dateTo,
          customerInfor.CusId,
          exportType,
        );
        if (response.success) {
          setInvoices(response.data.details);
          setSummary({
            TotalRevenue: response.data.totalRevenue || 0,
            TotalAllGtgt: response.data.totalAllGtgt || 0,
            TotalAllTncn: response.data.totalAllTncn || 0,
          });
        } else {
          toast.error(response.message);
          setInvoices([]);
          setSummary({
            TotalRevenue: 0,
            TotalAllGtgt: 0,
            TotalAllTncn: 0,
          });
        }
      }
    } catch (error) {
      toast.error(error);
      setInvoices([]);
      if (exportType === 0) {
        setSummary({
          TotalInvoice: 0,
          TotalInvoiceSync: 0,
          TotalInvoiceSign: 0,
          TotalItemAmount: 0,
          TotalDiscountAmount: 0,
          TotalBeforeTax: 0,
          TotalVatAmount: 0,
          TotalAfterTax: 0,
        });
      } else {
        setSummary({
          TotalRevenue: 0,
          TotalAllGtgt: 0,
          TotalAllTncn: 0,
        });
      }
    } finally {
    }
  };

  const handleTabChange = async (event, newValue) => {
    setCurrentTab(newValue);
    await GetSalesRevenueReport(newValue);
  };

  const renderTableContent = () => {
    switch (currentTab) {
      case 0:
        return (
          <ReportTableType
            invoices={invoices}
            summary={summary}
            formatVND={formatVND}
            stickyFooterStyle={stickyFooterStyle}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
          />
        );
      default:
        return null;
    }
  };
  const recalculateTax = async () => {
    if (currentTab > 2) {
      toast.error("Mẫu chưa có sẵn");
      return;
    }
    setConfirmDialogState({
      open: true,
      title: "Tính lại thuế",
      content:
        "Thuế GTGT và thuế TNCN sẽ được tính lại theo tỷ lệ ngành nghề hiện tại đã được cài đặt trong ký hiệu. Bạn có chắc chắn muốn tính lại không?",
      onConfirm: () => {
        setOpenDialogChoice(true);
        setConfirmDialogState({
          ...confirmDialogState,
          open: false,
        });
      },
      onClose: () =>
        setConfirmDialogState({
          ...confirmDialogState,
          open: false,
        }),
    });
  };
  const handleRecalculateTax = async (year, quarter) => {
    try {
      // let dateFrom = fromDate;
      // let dateTo = toDate;
      // if (type === 1) {
      //   dateFrom = dayjs()
      //     .set("year", year)
      //     .set("month", month - 1)
      //     .startOf("month");
      //   dateTo = dayjs()
      //     .set("year", year)
      //     .set("month", month - 1)
      //     .endOf("month");
      // }
      // if (type === 2) {
      //   switch (quarter) {
      //     case 1:
      //       dateFrom = dayjs().set("year", year).set("month", 0).set("date", 1);
      //       dateTo = dayjs().set("year", year).set("month", 2).set("date", 31);
      //       break;
      //     case 2:
      //       dateFrom = dayjs().set("year", year).set("month", 3).set("date", 1);
      //       dateTo = dayjs().set("year", year).set("month", 5).set("date", 30);
      //       break;
      //     case 3:
      //       dateFrom = dayjs().set("year", year).set("month", 6).set("date", 1);
      //       dateTo = dayjs().set("year", year).set("month", 8).set("date", 30);
      //       break;
      //     case 4:
      //       dateFrom = dayjs().set("year", year).set("month", 9).set("date", 1);
      //       dateTo = dayjs().set("year", year).set("month", 11).set("date", 31);
      //       break;
      //     default:
      //       break;
      //   }
      // }
      // if (type === 3) {
      //   dateFrom = dayjs().set("year", year).set("month", 0).set("date", 1);
      //   dateTo = dayjs().set("year", year).set("month", 11).set("date", 31);
      // }
      const response = await invoiceApi.RecalculateTax(
        year,
        quarter,
        customerInfor.CusId,
      );
      if (response.success) {
        toast.success("Đã tính lại thuế");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(error);
    } finally {
      await GetSalesRevenueReport(currentTab);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
      <Container maxWidth="xxl" sx={{ mt: 2, mb: 2 }}>
        <Grid container spacing={2}>
          {/* CỘT BÊN TRÁI: DANH SÁCH MẪU BÁO CÁO */}
          <Grid size={{ xs: 12, md: 2 }}>
            <Paper elevation={3} sx={{ borderRadius: 2, height: "100%" }}>
              <Typography
                variant="h6"
                sx={{
                  p: 2,
                  fontWeight: "bold",
                  borderBottom: "1px solid #ddd",
                }}
              >
                Mẫu Báo Cáo
              </Typography>

              <Tabs
                orientation="vertical"
                value={currentTab}
                onChange={handleTabChange}
                sx={{
                  borderRight: 1,
                  borderColor: "divider",
                  "& .MuiTab-root": {
                    alignItems: "flex-start",
                    textAlign: "left",
                    textTransform: "none",
                  },
                }}
              >
                <Tab
                  label={
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: "bold", textTransform: "none" }}
                      >
                        Báo cáo XHĐ
                      </Typography>
                      <Typography
                        variant="caption"
                        sx={{
                          color: "text.secondary",
                          fontSize: "0.7rem",
                          textTransform: "none",
                          ml: 2,
                        }}
                      >
                        Báo cáo xuất hóa đơn
                      </Typography>
                    </Box>
                  }
                />
              </Tabs>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, md: 10 }}>
            <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
              <Grid container spacing={1} sx={{ mb: 4 }}>
                <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
                  <TextField
                    select
                    label="Lọc theo"
                    fullWidth
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    size="small"
                  >
                    {searchType.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                {type === 0 && (
                  <>
                    <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
                      <DatePicker
                        label="Từ ngày"
                        value={fromDate}
                        onChange={(val) => setFromDate(val)}
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: { fullWidth: true, size: "small" },
                        }}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
                      <DatePicker
                        label="Đến ngày"
                        value={toDate}
                        onChange={(val) => setToDate(val)}
                        format="DD/MM/YYYY"
                        slotProps={{
                          textField: { fullWidth: true, size: "small" },
                        }}
                      />
                    </Grid>
                  </>
                )}
                {type === 1 && (
                  <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
                    <TextField
                      select
                      label="Tháng"
                      fullWidth
                      value={month}
                      onChange={(e) => setMonth(e.target.value)}
                      size="small"
                      align="center"
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: 180,
                            },
                          },
                        },
                      }}
                    >
                      {months.map((m) => (
                        <MenuItem key={m} value={m}>
                          Tháng {m}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}
                {type === 2 && (
                  <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
                    <TextField
                      select
                      label="Quý"
                      fullWidth
                      value={quarter}
                      onChange={(e) => setQuarter(e.target.value)}
                      size="small"
                    >
                      {quarters.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}
                {type !== 0 && (
                  <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
                    <TextField
                      select
                      label="Năm"
                      fullWidth
                      value={year}
                      onChange={(e) => setYear(e.target.value)}
                      size="small"
                      align="center"
                      SelectProps={{
                        MenuProps: {
                          PaperProps: {
                            style: {
                              maxHeight: 180,
                            },
                          },
                        },
                      }}
                    >
                      {years.map((y) => (
                        <MenuItem key={y} value={y}>
                          {y}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}
                {currentTab === 0 && (
                  <Grid size={{ xs: 12, md: 2 }} sx={{ minWidth: 150 }}>
                    <TextField
                      select
                      label="Ký hiệu hoá đơn"
                      fullWidth
                      value={symbol || "-1"}
                      onChange={(e) =>
                        setSymbol(e.target.value === -1 ? null : e.target.value)
                      }
                      size="small"
                    >
                      {invoiceTemplate.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                )}
                <Grid size={{ xs: 12, md: 4 }}>
                  <Stack direction="row" spacing={1}>
                    <Button
                      variant="contained"
                      startIcon={<SearchIcon />}
                      sx={{ px: 3, minWidth: 141 }}
                      onClick={() => GetSalesRevenueReport(currentTab)}
                    >
                      Tìm kiếm
                    </Button>
                    {currentTab === 0 ? (
                      <Button
                        variant="outlined"
                        color="success"
                        startIcon={<FileDownloadIcon />}
                        onClick={() => ExportInvoiceReport(currentTab)}
                        sx={{ minWidth: 141 }}
                      >
                        Xuất Excel
                      </Button>
                    ) : (
                      <>
                        <Button
                          variant="contained"
                          sx={{ minWidth: 141 }}
                          onClick={() => recalculateTax()}
                        >
                          Tính lại
                        </Button>
                        <Button
                          variant="outlined"
                          color="success"
                          startIcon={<FileDownloadIcon />}
                          onClick={() => ExportInvoiceReport(currentTab)}
                          sx={{ minWidth: 141 }}
                        >
                          Xuất PDF
                        </Button>
                      </>
                    )}
                  </Stack>
                </Grid>
              </Grid>
              {/* PHẦN TABLE DỰA TRÊN TAB ĐÃ CHỌN */}
              {renderTableContent()}
            </Paper>
          </Grid>
        </Grid>
      </Container>
      <ConfirmDialog
        open={confirmDialogState.open}
        title={confirmDialogState.title}
        content={confirmDialogState.content}
        onConfirm={confirmDialogState.onConfirm}
        onClose={confirmDialogState.onClose}
      />
      <Dialog open={openDialogChoice}>
        <DialogTitle>Chọn kỳ muốn tính lại thuế</DialogTitle>
        <Box sx={{ p: 3 }}>
          <TextField
            select
            label="Năm"
            fullWidth
            value={yearForRecalculate}
            onChange={(e) => setYearForRecalculate(e.target.value)}
            size="small"
            align="center"
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  style: {
                    maxHeight: 180,
                  },
                },
              },
            }}
            sx={{ mb: 2 }}
          >
            {years.map((y) => (
              <MenuItem key={y} value={y}>
                {y}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            select
            label="Quý"
            fullWidth
            value={quarterForRecalculate || -1}
            onChange={(e) =>
              setQuarterForRecalculate(
                e.target.value == -1 ? null : e.target.value,
              )
            }
            size="small"
          >
            {quarterAll.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="flex-end"
            sx={{ mt: 3 }}
          >
            <Button
              variant="outlined"
              onClick={() => setOpenDialogChoice(false)}
            >
              Hủy
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                handleRecalculateTax(yearForRecalculate, quarterForRecalculate);
                setOpenDialogChoice(false);
              }}
            >
              Xác nhận
            </Button>
          </Stack>
        </Box>
      </Dialog>
    </LocalizationProvider>
  );
};
const ReportTableType = ({
  invoices,
  summary,
  formatVND,
  stickyFooterStyle,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
}) => (
  <>
    <TableContainer
      component={Paper}
      variant="outlined"
      sx={{
        flexGrow: 1,
        height: "100%",
        overflowY: "auto",
        backgroundColor: "white",
      }}
    >
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow
            sx={{
              "& th": {
                backgroundColor: "#f8f9fa",
                fontWeight: "bold",
                zIndex: 3,
              },
            }}
          >
            <TableCell>Ngày HĐ</TableCell>
            <TableCell>Ký hiệu</TableCell>
            <TableCell align="center">Tổng phiếu</TableCell>
            <TableCell align="center">Đã đồng bộ</TableCell>
            <TableCell align="center">Đã ký</TableCell>
            <TableCell align="right">Tiền hàng</TableCell>
            <TableCell align="right">Chiết khấu</TableCell>
            <TableCell align="right">Trước thuế</TableCell>
            <TableCell align="right">Tiền thuế</TableCell>
            <TableCell align="right">Tổng tiền</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {invoices
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row) => (
              <TableRow key={row.STT} hover>
                {/* <TableCell>{dayjs(row.ReiDate).format("DD/MM/YYYY")}</TableCell> */}
                <TableCell>{row.Title}</TableCell>
                <TableCell>{row.ReiSign}</TableCell>
                <TableCell align="center">{row.TotalInvoice}</TableCell>
                <TableCell align="center" sx={{ color: "info.main" }}>
                  {row.TotalInvoiceSync}
                </TableCell>
                <TableCell align="center" sx={{ color: "success.main" }}>
                  {row.TotalInvoiceSign}
                </TableCell>
                <TableCell align="right">
                  {formatVND(row.TotalItemAmount)}
                </TableCell>
                <TableCell align="right" sx={{ color: "error.main" }}>
                  {formatVND(row.TotalDiscountAmount)}
                </TableCell>
                <TableCell align="right">
                  {formatVND(row.TotalBeforeTax)}
                </TableCell>
                <TableCell align="right">
                  {formatVND(row.TotalVatAmount)}
                </TableCell>
                <TableCell align="right" sx={{ fontWeight: 500 }}>
                  {formatVND(row.TotalAfterTax)}
                </TableCell>
              </TableRow>
            ))}

          {/* Dòng tổng cộng - Sử dụng Sticky CSS */}
          <TableRow>
            <TableCell colSpan={2} align="center" sx={stickyFooterStyle}>
              TỔNG CỘNG
            </TableCell>
            <TableCell align="center" sx={stickyFooterStyle}>
              {summary.TotalInvoice}
            </TableCell>
            <TableCell align="center" sx={stickyFooterStyle}>
              {summary.TotalInvoiceSync}
            </TableCell>
            <TableCell align="center" sx={stickyFooterStyle}>
              {summary.TotalInvoiceSign}
            </TableCell>
            <TableCell align="right" sx={stickyFooterStyle}>
              {formatVND(summary.TotalItemAmount)}
            </TableCell>
            <TableCell align="right" sx={stickyFooterStyle}>
              {formatVND(summary.TotalDiscountAmount)}
            </TableCell>
            <TableCell align="right" sx={stickyFooterStyle}>
              {formatVND(summary.TotalBeforeTax)}
            </TableCell>
            <TableCell align="right" sx={stickyFooterStyle}>
              {formatVND(summary.TotalVatAmount)}
            </TableCell>
            <TableCell
              align="right"
              sx={{ ...stickyFooterStyle, color: "#d32f2f" }}
            >
              {formatVND(summary.TotalAfterTax)}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>

    <TablePagination
      rowsPerPageOptions={[10, 25, 50, 500]}
      component="div"
      count={invoices.length}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={(e, p) => setPage(p)}
      onRowsPerPageChange={(e) => setRowsPerPage(parseInt(e.target.value, 10))}
      labelRowsPerPage="Số dòng mỗi trang:"
      labelDisplayedRows={({ from, to, count, page }) =>
        `Dòng ${from}–${to} trong tổng số ${count} dòng`
      }
    />
  </>
);

export default SalesRevenueReportPage;
